import {
  fetch,
  fetchwithoutToken,
  getHeaders,
  makeRequest,
} from "$utils/utils";
import config from "$services/config";

const { shipping_api_url: shipping_url } = config;

export const getParcels = async () => {
  try {
    const { data } = await fetch("/parcels", {}, shipping_url);
    return data;
  } catch (err) {
    console.error(err);
  }
};

export const getPackageTypes = async () => {
  try {
    const { data } = await fetchwithoutToken(
      "/public/packageTypes",
      {},
      shipping_url
    );
    if (!data.data) {
      throw new Error();
    }
    return data.data;
  } catch (err) {
    return [];
  }
};

export const getParcelByOpId = async (id: string) => {
  try {
    const { data } = await fetch(`/public/parcels/op/${id}`, {}, shipping_url);
    if (!data) {
      throw new Error();
    }
    return data;
  } catch (error: any) {
    return { error };
  }
};

export const updateParcel = async (token: string, id: string, body: any) => {
  try {
    const res = await makeRequest(
      `${shipping_url}/parcels/op/${id}`,
      "PUT",
      body,
      getHeaders(token)
    );
    return res.data;
  } catch (error: any) {
    return { error };
  }
};

export const createParcel = async (token: string, body: any) => {
  try {
    const res = await makeRequest(
      `${shipping_url}/parcels/op`,
      "POST",
      body,
      getHeaders(token)
    );
    return res.data;
  } catch (error: any) {
    return { error };
  }
};

export const deleteParcel = async (token: string, id: string) => {
  try {
    const res = await makeRequest(
      `${shipping_url}/parcels/op/${id}`,
      "DELETE",
      undefined,
      getHeaders(token)
    );
    return res.data;
  } catch (error: any) {
    return { error };
  }
};
